import type { ImgHTMLAttributes } from 'react';
import { brandConfig } from '@/config/brandConfig';
import { LOGO_BASE64 } from '@/utils/pdfConstants';
import { cn } from '@/lib/utils';

/** Keep the real brand mark visible if its public URL fails, including in print. */
export default function BrandLogo({
  className,
  alt = `${brandConfig.name} logo`,
  width = 40,
  height = 40,
  ...props
}: Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'onError'>) {
  return (
    <img
      {...props}
      src={brandConfig.logoPath}
      alt={alt}
      width={width}
      height={height}
      className={cn('shrink-0 object-contain', className)}
      onError={(event) => {
        const image = event.currentTarget;
        if (image.dataset.brandFallback) return;
        image.dataset.brandFallback = 'true';
        image.src = LOGO_BASE64;
      }}
    />
  );
}
